import { QueryErrorResetBoundary, type QueryKey } from '@tanstack/react-query';
import { cloneElement, type ReactElement, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

import { RetryQueryAlert } from '@/components/alerts/retry-query-alert';

type ErrorBoundarySuspenseProps = {
  loadingFallback: ReactElement;
  errorFallbackWrapper: ReactElement;
  queryKey: QueryKey;
  children: ReactElement;
  message?: string;
};

export function ErrorBoundarySuspense({
  loadingFallback,
  errorFallbackWrapper,
  queryKey,
  children,
  message,
}: ErrorBoundarySuspenseProps) {
  return (
    <QueryErrorResetBoundary>
      {({ reset }) => (
        <ErrorBoundary
          fallbackRender={({ resetErrorBoundary }) =>
            cloneElement(
              errorFallbackWrapper,
              {},
              <RetryQueryAlert
                message={message}
                onRetry={resetErrorBoundary}
                queryKey={queryKey}
              />,
            )
          }
          onReset={reset}
        >
          <Suspense fallback={loadingFallback}>{children}</Suspense>
        </ErrorBoundary>
      )}
    </QueryErrorResetBoundary>
  );
}
